var t=Object.prototype.toString;var r=function(r){return t.call(r)};export{r as default};
//# sourceMappingURL=_objectToString.js.map
